import Vue from 'vue';
import LeftIcon from 'vue-material-design-icons/ChevronLeftCircle';
import RightIcon from 'vue-material-design-icons/ChevronRightCircle';
import PlusIcon from 'vue-material-design-icons/PlusCircle';
import MinusIcon from 'vue-material-design-icons/MinusCircle';
import Flipbook from 'flipbook-vue';

const flipbookItemComponentConfig = {
    /**
     * Component name
     * @type {String}
     */
    name: 'flipbook-item',

    props: [ 'pages' ],

    /**
     * Component list
     * @type {Object}
     */
    components: {
        Flipbook,
        LeftIcon,
        RightIcon,
        PlusIcon,
        MinusIcon
    },

    /**
     * Component data
     * @return {Object}
     */
    data () {
        const dataObject = {
            pagesHiRes: [],
            hasMouse: true,
            pageNum: null
        };

        return dataObject;
    },

    /**
     * Created event handler
     * @return {Void}
     */
    created () {
        this.pagesHiRes = this.pages;
    },

    /**
     * Mounted function
     * @void
     */
    mounted () {
        console.log(this.$refs);

        window.addEventListener(
            'keydown',
            event => {
                let flipbook = this.$refs.flipbook;

                if (!flipbook) {
                    return false;
                }

                if ((event.keyCode === 37) && flipbook.canFlipLeft) {
                    flipbook.flipLeft();
                }

                if ((event.keyCode === 39) && flipbook.canFlipRight) {
                    flipbook.flipRight();
                }
            }
        );

        window.addEventListener(
            'hashchange',
            this.setPageFromHash()
        );

        this.setPageFromHash();
    },

    methods: {
        onFlipRightEnd (page) {
            window.location.hash = '#' + page;
        },

        onFlipLeftEnd (page) {
            window.location.hash = '#' + page;
        },

        setPageFromHash () {
            let hash = window.location.hash.slice(1);
            let num = parseInt(hash, 10);

            this.pageNum = isFinite(num) ? num : null;
        }
    }
};

const flipbookItemComponent = Vue.extend(flipbookItemComponentConfig);

export default flipbookItemComponent;
